// assets
import FileTextOutlined from '@ant-design/icons/FileTextOutlined';
import CalendarOutlined from '@ant-design/icons/CalendarOutlined';

// icons
const icons = { FileTextOutlined, CalendarOutlined };

// ==============================|| MENU ITEMS - GROUP PLANS ||============================== //

const groupPlans = {
  id: 'group_plans',
  title: 'Group Plans',
  type: 'collapse',
  url: '/group-plans', // Add URL for clickable behavior
  icon: icons.FileTextOutlined,
  permission: {
    module: 'group_plans',
    level: 10 // View permission required
  },
  children: [
    {
      id: 'expiring',
      title: 'Expiring',
      type: 'item',
      url: '/group-plans/expiring',
      icon: icons.CalendarOutlined,
      permission: {
        module: 'group_plans',
        level: 1 // Any permission level > 0
      }
    },
  ]
};

export default groupPlans;

